import { IThreeVariantXP } from '@faire/web-api--source/indigofair/settings/IThreeVariantXP';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Store type section experiment for discover pages - controls which variant to show:
 * - CONTROL: No store type section (default)
 * - VARIANT_2: Store type section under top picks
 * - VARIANT_3: Store type section above top picks
 * PRD: https://www.notion.so/faire/Store-type-section-on-Discover-pages-2342efb5c25a8028b62ad61f48fe412c
 */
export const DISCOVER_PAGE_STORE_TYPE_SECTION_250730 =
  'DISCOVER_PAGE_STORE_TYPE_SECTION_250730' as SettingConst<
    'DISCOVER_PAGE_STORE_TYPE_SECTION_250730',
    keyof typeof IThreeVariantXP.Bucket,
    'RETAILER' | 'VISITOR_WEB'
  >;
